import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductsPage.css';
import { ProductCard } from '../Products/Products'; // Import the ProductCard component
import Navbar from '../Navbar/Navbar'; // Import the Navbar component
import Footer from '../../components/Footer/Footer';
import ParticlesBackground from '../../components/ParticleBackground/ParticleBackground';

// Create a new ProjectGridCard component specifically for the ProjectsPage
const ProjectGridCard = ({ title, image, index, slug, navigate }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isOdd = index % 2 !== 0; // Determine if this is an odd-indexed card
  
  const handleClick = () => {
    if (slug && navigate) {
      navigate(`/project/${slug}`);
    }
  };
  
  return (
    <div 
      className={`project-grid-card ${isOdd ? 'odd-card' : 'even-card'}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="project-grid-overlay-color"></div>
      <img 
        src={image} 
        alt={title} 
        className="project-grid-image"
      />
      <div className="project-grid-overlay">
        <h3 className="project-grid-title">{title}</h3>
      </div>
    </div>
  );
};

const ProjectsPage = () => {
  const navigate = useNavigate();
  
  const [projects, setProjects] = useState([
    {
      id: 1,
      title: "DGE Cyber Security Week 2025",
      slug: "dge-cyber-security-week",
      category: "Technology",
      image: require('../../asset/Viola/banner.jpg')
    },
    {
      id: 2,
      title: "ADQ Carnival 2025",
      slug: "adq-carnival",
      category: "Corporate",
      image: require('../../asset/ADQ Carnival/1.JPG')
    },
    {
      id: 3,
      title: "Comex Oman 2024",
      slug: "comex-oman",
      category: "Corporate",
      image: require('../../asset/Comex/1.jpg')
    },
    {
      id: 4,
      title: "DU GITEX Northstar 2025",
      slug: "du-gitex-northstar",
      category: "Technology",
      image: require('../../asset/Northstar/1.jpg')
    },
    {
      id: 5,
      title: "NBA BRED Festival",
      slug: "nba-bred-festival",
      category: "Entertainment",
      image: require('../../asset/NBA BRED/1.jpg')
    },
    {
      id: 6,
      title: "Arab Health - American Hospital 2025",
      slug: "arab-health",
      category: "Healthcare",
      image: require('../../asset/Arab Health/1.JPEG')
    },
    {
      id: 7,
      title: "Global Freight Summit",
      slug: "global-freight-summit",
      category: "Corporate",
      image: require('../../asset/GPJ/1.jpg')
    },
    {
      id: 8,
      title: "Du Sharjah Entrepreneurship Festival 2025",
      slug: "du-sef",
      category: "Technology",
      image: require('../../asset/du SEF/1.jpeg')
    },
    {
      id: 9,
      title: "Arab Media Summit 2024",
      slug: "arab-media-summit",
      category: "Corporate",
      image: require('../../asset/Arab Media/1.jpg')
    },
    {
      id: 10,
      title: "Khazna Capacity 2025",
      slug: "khazana-capacity",
      category: "Corporate",
      image: require('../../asset/Khazana Capacity/1.jpeg')
    },
    {
      id: 11,
      title: "NBA Ramadan Majlis 2025",
      slug: "nba-ramadan-majlis",
      category: "Entertainment",
      image: require('../../asset/NBA Ramadan Majlis/1.jpg')
    },
    {
      id: 12,
      title: "Sharjah Reading Festival 2025",
      slug: "sharjah-festival",
      category: "Education",
      image: require('../../asset/Sharjah Festival/1.jpeg')
    }

    // COMMENTED OUT PROJECTS - Not in desired list:
    
    // {
    //   id: 4,
    //   title: "Du Capacity 2025",
    //   slug: "du-capacity",
    //   category: "Technology",
    //   image: require('../../asset/Du Capacity/1.jpeg')
    // },
    
    // {
    //   id: 5,
    //   title: "Du GT Commercial 2025",
    //   slug: "du-gt-commercial",
    //   category: "Entertainment",
    //   image: require('../../asset/du GT Commercial/1.JPEG')
    // },
    
    // {
    //   id: 8,
    //   title: "Medlab - American Hospital 2025",
    //   slug: "medlab",
    //   category: "Healthcare",
    //   image: require('../../asset/Medlab/1.jpg')
    // }
  ]);

  const [filteredProjects, setFilteredProjects] = useState([]);
  const [activeCategory, setActiveCategory] = useState('ALL');
  const categories = ['ALL', 'Corporate', 'Healthcare', 'Technology', 'Entertainment', 'Education'];

  // Initialize filtered projects with all projects
  useEffect(() => {
    setFilteredProjects(projects);
  }, [projects]);

  // Filter projects based on selected category
  const filterProjects = (category) => {
    setActiveCategory(category);
    if (category === 'ALL') {
      setFilteredProjects(projects);
    } else {
      const filtered = projects.filter(project => project.category === category);
      setFilteredProjects(filtered);
    }
  };

  // Keep the blob decoration useEffect
  useEffect(() => {
    const pageDecoration = document.querySelector('.projects-page-decoration');
    if (!pageDecoration) return;
    
    // Create a blob with specific vertical position and horizontal bias
    const createBlob = (verticalPosition, horizontalBias = null) => {
      const blob = document.createElement('div');
      blob.className = 'floating-blob';
      
      // Randomize horizontal position with optional bias
      let leftPosition;
      if (horizontalBias === 'far-left') {
        leftPosition = -5 + Math.random() * 15; // -5% to 10% (far left edge)
      } else if (horizontalBias === 'left') {
        leftPosition = 10 + Math.random() * 20; // 10% to 30% (left side)
      } else if (horizontalBias === 'center') {
        leftPosition = 30 + Math.random() * 40; // 30% to 70% (center)
      } else if (horizontalBias === 'right') {
        leftPosition = 70 + Math.random() * 20; // 70% to 90% (right side)
      } else if (horizontalBias === 'far-right') {
        leftPosition = 90 + Math.random() * 15; // 90% to 105% (far right edge)
      } else {
        leftPosition = 5 + Math.random() * 90; // 5% to 95% (full width)
      }
      
      blob.style.left = `${leftPosition}%`;
      
      // Set vertical position (negative to be above the viewport)
      blob.style.top = `${verticalPosition}px`;
      
      // Randomize size
      const size = 100 + Math.random() * 200; // Random size between 100px and 300px
      blob.style.width = `${size}px`;
      blob.style.height = `${size}px`;
      
      // Randomize opacity and color intensity
      const opacity = 0.25 + Math.random() * 0.15; // Between 0.25 and 0.4
      blob.style.background = `rgba(227, 41, 97, ${opacity})`;
      
      // Set parallax speed
      blob.dataset.speed = 0.2 + Math.random() * 0.2; // Random speed between 0.2 and 0.4
      
      return blob;
    };
    
    // Create blobs with better distribution
    const totalBlobs = 65;
    const blobs = [];
    
    // Position blobs from -15000px up to the top of the viewport
    // with even distribution across far-left, left, center, right, and far-right
    for (let i = 0; i < totalBlobs; i++) {
      const verticalPosition = -15000 + (i * (15000 / totalBlobs));
      
      // Determine horizontal bias based on position
      let horizontalBias;
      const position = i % 5;
      if (position === 0) horizontalBias = 'far-left';
      else if (position === 1) horizontalBias = 'left';
      else if (position === 2) horizontalBias = 'center';
      else if (position === 3) horizontalBias = 'right';
      else horizontalBias = 'far-right';
      
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add extra blobs near the top with explicit edge bias
    for (let i = 0; i < 15; i++) {
      // Cycle through all positions for the extra blobs
      const positions = ['far-left', 'left', 'center', 'right', 'far-right'];
      const horizontalBias = positions[i % 5];
      const verticalPosition = -500 - (i * 300); // Position between -500px and -4900px
      const blob = createBlob(verticalPosition, horizontalBias);
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Add specific blobs at the far left edges
    for (let i = 0; i < 5; i++) {
      const verticalPosition = -1000 - (i * 800); // Well-spaced vertical positions
      const blob = createBlob(verticalPosition, 'far-left');
      pageDecoration.appendChild(blob);
      blobs.push(blob);
    }
    
    // Handle scroll to move blobs with parallax effect
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      
      // Update all blobs position
      blobs.forEach((blob) => {
        const speed = parseFloat(blob.dataset.speed) || 0.3;
        const initialTop = parseInt(blob.style.top) || 0;
        
        // Apply parallax movement
        blob.style.transform = `translateY(${currentScrollY * speed}px)`;
        
        // Calculate actual position
        const blobTop = initialTop + (currentScrollY * speed);
        
        // Make blobs visible only when they're near or in the viewport
        if (blobTop < -viewportHeight || blobTop > viewportHeight * 2) {
          blob.style.opacity = '0';
        } else {
          // Fade in as they approach the viewport
          const distance = Math.abs(blobTop);
          const maxDistance = viewportHeight;
          // Opacity range: minimum 0.2, maximum 0.5
          const opacity = 0.2 + (0.3 * (1 - Math.min(distance / maxDistance, 1)));
          blob.style.opacity = opacity.toString();
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Call once to set initial positions
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Clean up blobs
      blobs.forEach(blob => {
        if (pageDecoration.contains(blob)) {
          pageDecoration.removeChild(blob);
        }
      });
    };
  }, []);

  return (
    <div className="projects-page">
      <ParticlesBackground />
      
      {/* Container for dynamically created blobs */}
      <div className="projects-page-decoration"></div>
      
      {/* Navbar outside the content container */}
      <div className="navbar-wrapper">
        <Navbar />
      </div>
      
      <div className="content-container">
        <div className="projects-header">
          <div className="page-title-container">
            <h1 className="page-title">Our Projects</h1>
            <div className="title-underline"></div>
          </div>
          
          <div className="category-filters">
            {categories.map(category => (
              <button 
                key={category}
                className={`category-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => filterProjects(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
        
        <div className="projects-grid">
          {filteredProjects.map((project, index) => (
            <div className="project-card-wrapper" key={project.id}>
              <ProjectGridCard 
                title={project.title}
                image={project.image}
                index={index}
                slug={project.slug}
                navigate={navigate}
              />
            </div>
          ))}
        </div>
      </div>
      
      <style>
        {`
          /* Remove .dg.ac and fluid-simulation styles as they'll be handled by FluidBackground */
          
          /* Page-wide blob styling */
          .projects-page-decoration {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            minHeight: 100vh;
            minHeight: 100dvh; /* Better mobile support */
            pointer-events: none;
            z-index: 1;
            overflow: hidden;
          }
          
          /* Ensure particles background covers full screen on all devices */
          .particle-background-container {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            min-height: 100vh !important;
            min-height: 100dvh !important; /* Better mobile support */
            min-height: -webkit-fill-available !important; /* Safari/Mac fix */
            z-index: 0 !important;
            pointer-events: none !important;
          }
          
          .floating-blob {
            position: absolute;
            border-radius: 50%;
            filter: blur(15px);
            box-shadow: 0 0 25px rgba(227, 41, 97, 0.5);
            will-change: transform, opacity;
            transition: opacity 0.5s ease;
          }
          
          /* Navbar styling */
          .navbar-wrapper {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 10;
            background: rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(10px);
          }
          
          /* Content container styling */
          .content-container {
            position: relative;
            z-index: 2;
            padding: 2rem;
            max-width: 1400px;
            margin: 0 auto;
            padding-top: 120px; /* Add extra padding to account for fixed navbar */
          }
          
          /* Projects header styling */
          .projects-header {
            margin-bottom: 3rem;
            text-align: center;
            position: relative;
          }
          
          .page-title-container {
            position: relative;
            display: inline-block;
            margin-bottom: 2rem;
            padding: 10px 30px; /* Add padding to create space for the decorative corners */
          }
          
          .page-title {
            font-size: 3.5rem;
            margin: 0;
            color: #fff;
            text-shadow: 0 0 15px rgba(227, 41, 97, 0.7);
            font-weight: 700;
            letter-spacing: 2px;
            position: relative;
            z-index: 2;
            text-align: center; /* Ensure text is centered */
          }
          
          .title-underline {
            height: 4px;
            width: 60%;
            background: linear-gradient(90deg, transparent, rgba(227, 41, 97, 0.8), transparent);
            margin: 0 auto;
            border-radius: 2px;
            box-shadow: 0 0 10px rgba(227, 41, 97, 0.5);
          }
          
          /* Adjust decorative elements for the title */
          .page-title-container::before,
          .page-title-container::after {
            content: '';
            position: absolute;
            width: 40px;
            height: 40px;
            border: 3px solid rgba(227, 41, 97, 0.6);
            z-index: 1;
          }
          
          .page-title-container::before {
            top: 0;
            left: 0;
            border-right: none;
            border-bottom: none;
          }
          
          .page-title-container::after {
            bottom: 0;
            right: 0;
            border-left: none;
            border-top: none;
          }
          
          /* Category filters styling */
          .category-filters {
            display: flex;
            justify-content: center;
            gap: 1rem;
            margin-bottom: 2rem;
          }
          
          .category-btn {
            padding: 0.8rem 1.5rem;
            background-color: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 8px;
            color: #fff;
            font-size: 1rem;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          
          .category-btn:hover {
            background-color: rgba(227, 41, 97, 0.3);
            border-color: rgba(227, 41, 97, 0.5);
          }
          
          .category-btn.active {
            background-color: #e32961;
            border-color: #e32961;
            box-shadow: 0 0 15px rgba(227, 41, 97, 0.5);
          }
          
          /* Projects grid styling - unified grid */
          .projects-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 0; /* Remove all gaps between grid items */
            width: 100%;
          }
          
          /* Project card wrapper to ensure square aspect ratio */
          .project-card-wrapper {
            position: relative;
            width: 100%;
            padding-bottom: 100%; /* Creates a square aspect ratio */
            overflow: hidden;
          }
          
          /* New ProjectGridCard styling */
          .project-grid-card {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.3s ease;
          }
          
          .project-grid-card:hover {
            transform: scale(0.9); /* Changed from 1.05 to 0.95 to reduce size on hover */
            z-index: 3;
          }
          
          /* Color overlay for alternating tiles */
          .project-grid-overlay-color {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            mix-blend-mode: overlay;
            opacity: 0.5;
            transition: opacity 0.3s ease;
          }
          
          .odd-card .project-grid-overlay-color {
            background-color: black;
          }
          
          .even-card .project-grid-overlay-color {
            background-color: white;
          }
          
          .project-grid-card:hover .project-grid-overlay-color {
            opacity: 0.25;
          }
          
          /* Additional full overlay for all cards */
          .project-grid-card::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6); /* Black overlay with 0.6 opacity */
            z-index: 1;
            transition: background-color 0.3s ease;
          }
          
          .project-grid-card:hover::after {
            background-color: rgba(0, 0, 0, 0.5); /* Black overlay with 0.5 opacity on hover */
          }
          
          /* Ensure the overlay is above the image but below other elements */
          .project-grid-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.5s ease;
            position: relative;
            z-index: 0;
          }
          
          .project-grid-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
            padding: 25px 15px 20px 15px;
            transition: all 0.3s ease;
            z-index: 3; /* Increased to be above both overlays */
            box-sizing: border-box;
            min-height: 90px;
          }
          
          .project-grid-title {
            color: white;
            margin: 0;
            font-size: 1rem;
            font-weight: 600;
            text-align: center;
            text-shadow: 0 2px 4px rgba(0,0,0,0.5);
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
            line-height: 1.2;
            width: 100%;
            box-sizing: border-box;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            max-height: 3.6em;
            padding: 0 5px;
          }
          
          /* Responsive adjustments */
          @media (max-width: 1200px) {
            .projects-grid {
              grid-template-columns: repeat(3, 1fr);
            }
          }
          
          @media (max-width: 900px) {
            .projects-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
          
          @media (max-width: 768px) {
            .page-title {
              font-size: 2.8rem;
            }
            
            .page-title-container::before,
            .page-title-container::after {
              width: 30px;
              height: 30px;
            }
          }
          
          @media (max-width: 600px) {
            .projects-grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 0; /* Ensure no gaps on mobile */
            }
            
            .category-filters {
              flex-wrap: wrap;
            }
            
            .content-container {
              padding: 1rem;
              padding-top: 100px;
            }
            
            .page-title {
              font-size: 2.2rem;
            }
            
            .page-title-container::before,
            .page-title-container::after {
              width: 20px;
              height: 20px;
            }
            
            .project-grid-title {
              font-size: 0.85rem;
              -webkit-line-clamp: 3;
              max-height: 3.1em;
              padding: 0 3px;
            }
            
            .project-grid-overlay {
              padding: 20px 8px 15px 8px;
              min-height: 80px;
            }
          }
          
          /* Remove promo styling as it will be handled by FluidBackground */
          
          /* Mobile-specific fixes for particle background */
          @media screen and (max-width: 768px) {
            .products-page {
              min-height: 100vh;
              min-height: 100dvh; /* Dynamic viewport height for mobile */
              min-height: -webkit-fill-available; /* Safari fallback */
            }
            
            .particle-background-container,
            .projects-page-decoration {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
              max-height: none !important;
              z-index: 0 !important;
            }
            
            /* Ensure tsparticles canvas covers full screen */
            #tsparticles {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: 100dvh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Mac/Safari specific fixes for full viewport coverage */
          @media screen and (-webkit-min-device-pixel-ratio: 1) {
            .particle-background-container,
            .projects-page-decoration {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
            
            #tsparticles {
              height: 100vh !important;
              min-height: 100vh !important;
              min-height: -webkit-fill-available !important;
            }
          }
          
          /* Additional Safari-specific fix */
          @supports (-webkit-appearance: none) and (not (contain: paint)) {
            .particle-background-container,
            .projects-page-decoration,
            #tsparticles {
              height: calc(100vh + 1px) !important;
              min-height: calc(100vh + 1px) !important;
            }
          }
        `}
      </style>
      <Footer />
    </div>
  );
};

export default ProjectsPage; 